export const saveClickId = () => {
  const params = new URLSearchParams(window.location.search);

  const clickId =
    params.get("rtkclickid") ||
    params.get("clickid");

  if (clickId) {
    localStorage.setItem("redtrack_clickid", clickId);
  }
};

export const fireRedTrackLead = ({ email, phone, firstName, lastName, zipCode }) => {
  try {
    const clickId = sessionStorage.getItem("rt_clickid") || "";

    if (!clickId) {
      console.log("No RedTrack click ID found");
      return;
    }

    const img = new Image();

    img.src =
      "https://track.utatrack.com/postback" +
      "?clickid=" +
      encodeURIComponent(clickId) +
      "&type=Lead" +
      "&status=approved" +
      "&ptoken=4agttvklfk" +
      "&sub1=" +
      encodeURIComponent(email || "") +
      "&sub2=" +
      encodeURIComponent(phone || "") +
      "&sub3=" +
      encodeURIComponent(firstName || "") +
      "&sub4=" +
      encodeURIComponent(lastName || "") +
      // "&sub5=" +
      // encodeURIComponent(zipCode || "");

      console.log("RedTrack lead fired");
  } catch (error) {
    console.error("RedTrack error:", error);
  }
};